import React, { Component } from "react";
import { Button, Modal } from "reactstrap";
import RecordRTC from "recordrtc";
import { captureUserMedia } from "./utils";
import "./RecordVideo.css";

const hasGetUserMedia = !!(
  navigator.getUserMedia ||
  navigator.webkitGetUserMedia ||
  navigator.mozGetUserMedia ||
  navigator.msGetUserMedia
);

class RecordText extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recordVideo: null,
      src: null,
      uploadSuccess: null,
      uploading: false,
      recorded: false
    };

    this.stream = null;

    this.requestUserMedia = this.requestUserMedia.bind(this);
    this.startRecord = this.startRecord.bind(this);
    this.stopRecord = this.stopRecord.bind(this);
    this.resetRecord = this.resetRecord.bind(this);
    this.uploadVideo = this.uploadVideo.bind(this);
  }

  componentDidMount() {
    var pipeParams = {
      size: { width: 640, height: 480 },
      qualityurl: "avq/480p.xml",
      accountHash: "f642de5db52e5e18a9cd8d8c06c58753",
      eid: 1,
      mrt: 120,
      asv: 0,
      normalCol: "0x6CB9A8"
    };

    var uploadFunc = (streamName, location) => {
      var args = Array.prototype.slice.call(arguments);
      let url = `https://${location}/f642de5db52e5e18a9cd8d8c06c58753/${streamName}.mp4`;
      console.log(url);
      this.props.uploadVideo(url);
    };

    window.PipeSDK.insert("pipe-insert", pipeParams, recorderObject => {
      recorderObject.onVideoUploadSuccess = (
        recorderId,
        filename,
        filetype,
        videoId,
        audioOnly,
        location
      ) => {
        uploadFunc(filename, location);
      };

      recorderObject.onSaveOk = (
        recorderId,
        streamName,
        streamDuration,
        cameraName,
        micName,
        audioCodec,
        videoCodec,
        filetype,
        videoId,
        audioOnly,
        location
      ) => {
        uploadFunc(streamName, location);
      };
    });
  }

  componentWillUnmount() {}

  requestUserMedia() {
    console.log("requestUserMedia");

    return;

    var params = { audio: true, video: true };

    navigator.getUserMedia(
      params,
      stream => {
        this.setState({ src: window.URL.createObjectURL(stream) });
        this.stream = stream;
        this.stopStream = () => {
          stream.getTracks().forEach(function(track) {
            track.stop();
          });
        };
        console.log("setting state", this.state);
      },
      error => {
        console.error("getUserMedia error", error);
      }
    );
  }

  startRecord() {
    captureUserMedia(stream => {
      window.stream = stream;
      this.recordVideo = RecordRTC(stream, {
        mimeType: "video/webm;codecs=h264",
        bitsPerSecond: 1280000,
        width: 720,
        height: 480,
        plugins: {
          record: {
            audio: true,
            video: true,
            maxLength: 2,
            debug: true
          }
        }
      });
      this.recordVideo.startRecording();
    });

    this.setState({ recording: true });

    // setTimeout(() => {
    //   this.stopRecord();
    // }, 4000);
  }

  resetRecord() {
    this.setState({ recorded: false });
    this.requestUserMedia();
  }

  stopRecord() {
    this.setState({ recording: false });

    this.recordVideo.stopRecording(() => {
      this.recordVideo.getDataURL(dataURL => {
        this.setState({ previewData: dataURL });
      });

      this.setState({ recorded: true });
    });
  }

  uploadVideo() {
    // this.stream.getTracks().forEach(function (track) { track.stop(); });
    // this.stream.getTracks()[1].stop();
    // this.stream.getVideoTracks()[0].stop();
    // this.stream = null;
    window.stream.getTracks().forEach(function(track) {
      track.stop();
    });

    this.stopStream();

    this.setState({ uploading: true });

    this.props.uploadVideo(this.recordVideo.blob);

    // let streams = this.stream.getTracks();
    // window.URL.revokeObjectURL(this.state.src);
    // console.log(streams);
    // streams.forEach((track) => {
    //   console.log("TRACK", track);
    //   track.stop();
    // });

    // console.log(streams);
  }

  render() {
    return (
      <div className="Step RecordVideo">
        <h1>{this.props.headline}</h1>
        {this.props.description && (
          <div
            dangerouslySetInnerHTML={this.props.createMarkup(
              this.props.description
            )}
          />
        )}
        <div id="pipe-insert" />
      </div>
    );
  }
}

export default RecordText;



// WEBPACK FOOTER //
// ./src/RecordVideo.js